/* The Amenity Company — Ritual theme */
(function () {
  'use strict';

  /* Cost-per-stay calculator */
  document.querySelectorAll('[data-calc]').forEach(function (calc) {
    var baths = calc.querySelector('[data-calc-baths]');
    var stays = calc.querySelector('[data-calc-stays]');
    var turnsOut = calc.querySelector('[data-calc-turns]');
    var costOut = calc.querySelector('[data-calc-cost]');
    var cost = parseFloat(calc.getAttribute('data-cost-per-turn'));
    var currency = calc.getAttribute('data-currency') || 'USD';
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }); } catch (e) { fmt = null; }

    function clamp(input) {
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 999;
      var v = parseInt(input.value, 10);
      if (isNaN(v)) v = min;
      input.value = Math.max(min, Math.min(max, v));
      return parseInt(input.value, 10);
    }
    function update() {
      var turns = clamp(baths) * clamp(stays);
      turnsOut.textContent = turns;
      if (costOut) {
        if (!isNaN(cost) && cost > 0) {
          var total = turns * cost;
          costOut.textContent = fmt ? fmt.format(total) : total.toFixed(2);
        }
      }
    }
    calc.querySelectorAll('[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = calc.querySelector('[data-calc-' + btn.getAttribute('data-target') + ']');
        target.value = (parseInt(target.value, 10) || 0) + parseInt(btn.getAttribute('data-step'), 10);
        update();
      });
    });
    [baths, stays].forEach(function (i) { i.addEventListener('change', update); i.addEventListener('input', update); });
    update();
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-delta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var min = parseInt(input.min, 10);
        if (isNaN(min)) min = 0;
        var v = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-delta'), 10);
        input.value = Math.max(min, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Product page: variant selection and gallery */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-product-price]');
    var buyBtn = root.querySelector('[data-add-button]');
    var selects = root.querySelectorAll('[data-option-index]');
    var mainImg = root.querySelector('.product__main-img img');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var moneyFmt;
    try { moneyFmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: root.getAttribute('data-currency') || 'USD' }); } catch (e) { moneyFmt = null; }
    function money(cents) { return moneyFmt ? moneyFmt.format(cents / 100) : (cents / 100).toFixed(2); }

    function showImage(src, srcset, alt) {
      if (!mainImg || !src) return;
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset; else mainImg.removeAttribute('srcset');
      if (alt) mainImg.alt = alt;
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        showImage(t.getAttribute('data-src'), t.getAttribute('data-srcset'), t.getAttribute('data-alt'));
      });
    });

    function onChange() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!variant) {
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        var html = '<span>' + money(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) html += '<s>' + money(variant.compare_at_price) + '</s>';
        priceEl.innerHTML = html;
      }
      if (buyBtn) {
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? buyBtn.getAttribute('data-label') : 'Sold out';
      }
      if (variant.featured_image) {
        var w = variant.featured_image.src;
        showImage(w + (w.indexOf('?') > -1 ? '&' : '?') + 'width=1400', null, variant.featured_image.alt);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', onChange); });
  });

  /* Collection sort */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Close the mobile menu on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-drawer][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary'); if (s) s.focus();
    });
  });
})();
